<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="41.722" height="41.722" viewBox="0 0 41.722 41.722">
    <g id="Сгруппировать_3144" data-name="Сгруппировать 3144" transform="translate(-1125 -620)">
      <g id="Сгруппировать_3143" data-name="Сгруппировать 3143" transform="translate(1125 620)">
        <path id="Контур_3586" data-name="Контур 3586" d="M20.943,0A20.933,20.933,0,0,0,0,20.78,21.073,21.073,0,0,0,20.943,41.722,20.861,20.861,0,0,0,20.943,0Z" transform="translate(0)" fill="#fedb41"/>
        <path id="Контур_3588" data-name="Контур 3588" d="M76.025,60A15.944,15.944,0,1,0,91.887,75.862,16.033,16.033,0,0,0,76.025,60Z" transform="translate(-55.082 -55.082)" fill="#fea832"/>
        <text id="F" transform="translate(11.703 32.04)" fill="#fedb41" font-size="29" font-family="Helvetica"><tspan x="0" y="0">F</tspan></text>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconFoxcoin',
  }
</script>
